import urls from "../global/constants/UrlConstants";
import { getCallParams, makeCall } from "../utils/service";

const base = urls.url_prod;

export async function listChannelPartners(query: Record<string, any> = {}) {
  const cleaned: Record<string, string> = {};
  Object.entries(query).forEach(([k, v]) => {
    if (v == null || v === "") return;
    cleaned[k] = String(v);
  });
  const callParams = await getCallParams("GET", cleaned);
  return makeCall(`${base}/channel-partners`, callParams);
}

export async function getChannelPartner(id: string) {
  const callParams = await getCallParams("GET");
  return makeCall(`${base}/channel-partners/${id}`, callParams);
}

export async function createChannelPartner(body: Record<string, any>) {
  const callParams = await getCallParams("POST", body);
  return makeCall(`${base}/channel-partners`, callParams);
}

export async function updateChannelPartner(
  id: string,
  body: Record<string, any>
) {
  const callParams = await getCallParams("PUT", body);
  return makeCall(`${base}/channel-partners/${id}`, callParams);
}

export async function listChannelPartnerLeads(
  id: string,
  query: Record<string, any> = {}
) {
  const qs = new URLSearchParams(
    Object.entries(query)
      .filter(([, v]) => v != null && v !== "")
      .map(([k, v]) => [k, String(v)])
  ).toString();
  const callParams = await getCallParams("GET");
  return makeCall(
    `${base}/channel-partners/${id}/leads${qs ? `?${qs}` : ""}`,
    callParams
  );
}

export async function createChannelPartnerLead(
  id: string,
  body: Record<string, any>
) {
  const callParams = await getCallParams("POST", body);
  return makeCall(`${base}/channel-partners/${id}/leads`, callParams);
}

export async function listAssignableChannelPartners(
  organizationId: string,
  projectId?: string
) {
  const qs = new URLSearchParams({ organizationId });
  if (projectId) qs.set("projectId", projectId);
  const callParams = await getCallParams("GET");
  return makeCall(
    `${base}/channel-partners/assignable?${qs.toString()}`,
    callParams
  );
}

export async function assignChannelPartnerToLead(body: {
  leadId: string;
  channelPartnerId?: string;
  clear?: boolean;
  organizationId?: string;
}) {
  const callParams = await getCallParams("PUT", body);
  return makeCall(`${base}/leads/assign-channel-partner`, callParams);
}

export async function moveLead(body: {
  leadId: string;
  organizationId?: string;
  projectId?: string;
  formId?: string;
  channelPartnerId?: string;
}) {
  const callParams = await getCallParams("PUT", body);
  return makeCall(`${base}/leads/move`, callParams);
}
